
// Acción lista general bajas
export const LISTADO_GENERAL_BAJAS_REQUEST = 'LISTADO_GENERAL_BAJAS_REQUEST';
export const LISTADO_GENERAL_BAJAS_SUCCESS = 'LISTADO_GENERAL_BAJAS_SUCCESS';
export const LISTADO_GENERAL_BAJAS_FAIL = 'LISTADO_GENERAL_BAJAS_FAIL';
// Acción lista tabla bajas
export const LISTA_BAJAS_REQUEST = 'LISTA_BAJAS_REQUEST';
export const LISTA_BAJAS_SUCCESS = 'LISTA_BAJAS_SUCCESS';
export const LISTA_BAJAS_FAIL = 'LISTA_BAJAS_FAIL';
// Acción obtener bajas desde fecha inicio y termino
export const OBTENER_BAJAS_REQUEST = 'OBTENER_BAJAS_REQUEST';
export const OBTENER_BAJAS_SUCCESS = 'OBTENER_BAJAS_SUCCESS';
export const OBTENER_BAJAS_FAIL = 'OBTENER_BAJAS_FAIL';

// Acción registrar bienes bajas
export const REGISTRAR_BIENES_BAJAS_REQUEST = 'REGISTRAR_BIENES_BAJAS_REQUEST';
export const REGISTRAR_BIENES_BAJAS_SUCCESS = 'REGISTRAR_BIENES_BAJAS_SUCCESS';
export const REGISTRAR_BIENES_BAJAS_FAIL = 'REGISTRAR_BIENES_BAJAS_FAIL';

// Acción registrar bajas
export const REGISTRAR_BAJAS_REQUEST = 'REGISTRAR_BAJAS_REQUEST';
export const REGISTRAR_BAJAS_SUCCESS = 'REGISTRAR_BAJAS_SUCCESS';
export const REGISTRAR_BAJAS_FAIL = 'REGISTRAR_BAJAS_FAIL';
// Acción excluir Bajas
export const EXCLUIR_BODEGA_REQUEST = 'EXCLUIR_BODEGA_REQUEST';
export const EXCLUIR_BODEGA_SUCCESS = 'EXCLUIR_BODEGA_SUCCESS';
export const EXCLUIR_BODEGA_FAIL = 'EXCLUIR_BODEGA_FAIL';

// Acción obtener lista excluidos
export const OBTENER_EXCLUIDOS_REQUEST = 'OBTENER_EXCLUIDOS_REQUEST';
export const OBTENER_EXCLUIDOS_SUCCESS = 'OBTENER_EXCLUIDOS_SUCCESS';
export const OBTENER_EXCLUIDOS_FAIL = 'OBTENER_EXCLUIDOS_FAIL';

// Acción registrar excluidos
export const REGISTRAR_EXCLUIDOS_REQUEST = 'REGISTRAR_EXCLUIDOS_REQUEST';
export const REGISTRAR_EXCLUIDOS_SUCCESS = 'REGISTRAR_EXCLUIDOS_SUCCESS';
export const REGISTRAR_EXCLUIDOS_FAIL = 'REGISTRAR_EXCLUIDOS_FAIL';

// Acción devolver bajas
export const DEVOLVER_BAJAS_REQUEST = 'DEVOLVER_BAJAS_REQUEST';
export const DEVOLVER_BAJAS_SUCCESS = 'DEVOLVER_BAJAS_SUCCESS';
export const DEVOLVER_BAJAS_FAIL = 'DEVOLVER_BAJAS_FAIL';

// Acción obtener lista remates
export const OBTENER_REMATES_REQUEST = 'OBTENER_REMATES_REQUEST';
export const OBTENER_REMATES_SUCCESS = 'OBTENER_REMATES_SUCCESS';
export const OBTENER_REMATES_FAIL = 'OBTENER_REMATES_FAIL';

// Acción registrar remates
export const REGISTRAR_REMATES_REQUEST = 'REGISTRAR_REMATES_REQUEST';
export const REGISTRAR_REMATES_SUCCESS = 'REGISTRAR_REMATES_SUCCESS';
export const REGISTRAR_REMATES_FAIL = 'REGISTRAR_REMATES_FAIL';

// Acción quitar de bodega de excluidos
export const QUITAR_BODEGA_EXCLUIDOS_REQUEST = 'QUITAR_BODEGA_EXCLUIDOS_REQUEST';
export const QUITAR_BODEGA_EXCLUIDOS_SUCCESS = 'QUITAR_BODEGA_EXCLUIDOS_SUCCESS';
export const QUITAR_BODEGA_EXCLUIDOS_FAIL = 'QUITAR_BODEGA_EXCLUIDOS_FAIL';
